import type { SvgComponent } from '@/types/SvgComponent';

export const VideoCameraLockIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g>
        <path
          d="M2.25 10.5V6.75C2.25 6.33579 2.58579 6 3 6H18C18.4142 6 18.75 6.33579 18.75 6.75V17.25C18.75 17.6642 18.4142 18 18 18H14"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 10.5L23.25 7.5V16.5L18.75 13.5"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 15.5H2.25V20.5H11.25V15.5Z"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.25 15.5V14C4.25 13.337 4.51339 12.7011 4.98223 12.2322C5.45107 11.7634 6.08696 11.5 6.75 11.5C7.41304 11.5 8.04893 11.7634 8.51777 12.2322C8.98661 12.7011 9.25 13.337 9.25 14V15.5"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
